import { BaseRecord } from '@refinedev/core';
import { create } from 'zustand';

export interface PrintStoreConfig {
  storageKey: string;
}

export interface PrintState extends BaseRecord {
  printMode: boolean;
  loading: boolean;
  error: null;
}

interface PrintActions {
  setPrintMode: (printMode: boolean) => void;
  setPrintOptionsStructure: (structure: any) => void;
}

type PrintStore = PrintState & PrintActions & { config: PrintStoreConfig };

export const printStoreConfig: PrintStoreConfig = {
  storageKey: 'printState',
};

export const usePrintStore = create<PrintStore>((set) => ({
  printMode: false,
  printOptions: {},
  printOptionsStructure: null,
  loading: false,
  error: null,
  config: printStoreConfig,
  setPrintOptions: (printOptions: any) => set({ printOptions }),
  setPrintMode: (printMode: any) => set({ printMode }),
  setPrintOptionsStructure: (structure: any) => set({ printOptionsStructure: structure }),
}));
